module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/connect_confirmed-cc3209d7fc4e21fbc562f4c4e480818d.png";